import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "flex flex-col justify-between gap-y-4 bg-grey-50 pb-10 pt-4 lg:pt-10" };
const _hoisted_2 = { class: "flex w-full flex-col gap-3.5 px-4 lg:gap-8 lg:px-5" };
const _hoisted_3 = { class: "!my-0 flex flex-col gap-3.5 lg:gap-8" };
const _hoisted_4 = { class: "border-b border-black pb-3.5 font-bold first:font-light lg:pb-8" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "!mb-1" };
const _hoisted_7 = {
    key: 0,
    class: "!my-0 px-4 font-bold lg:px-5"
};
const _hoisted_8 = {
    key: 0,
    class: "flex w-full overflow-hidden 2xl:col-span-2"
};
const _hoisted_9 = {
    key: 0,
    class: "relative h-full w-full overflow-hidden"
};
import { computed } from 'vue';
import { useMq } from 'vue3-mq';
import HeroMedia from '@molecules/HeroMedia.vue';
import SinglePicture from '@atoms/SinglePicture.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpotlightHeader',
    props: {
        breadcrumbTextOverride: {},
        parentPage: {},
        title: {},
        subTitle: {},
        image: {},
        mediaType: {},
        mobileImage: {},
        videoEmbed: {},
        mobileVideoEmbed: {},
        videoFile: {},
        mobileVideoFile: {},
        mobileMediaType: {}
    },
    setup(__props) {
        const screen = useMq();
        const props = __props;
        const wrapperClasses = computed(() => {
            return screen.lgPlus ? 'container' : '';
        });
        const hasImage = computed(() => {
            return !!props.image?.url;
        });
        const hasDesktopVideo = computed(() => {
            return ((props.videoEmbed && props.videoEmbed.length > 0) ||
                (props.videoFile !== undefined && props.videoFile !== null));
        });
        const hasMedia = computed(() => {
            return hasImage.value || hasDesktopVideo.value;
        });
        const parentPageTitle = computed(() => {
            return props.breadcrumbTextOverride !== null &&
                props.breadcrumbTextOverride !== ''
                ? props.breadcrumbTextOverride
                : props.parentPage.title;
        });
        const hasVideoContent = computed(() => {
            return (props.mediaType === 'video_file' || props.mediaType === 'video_embed');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["grid grid-cols-1 gap-x-5 gap-y-0 lg:grid-cols-2 lg:pt-5 2xl:grid-cols-3", wrapperClasses.value]),
                "data-spotlight-header": ""
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("a", {
                                    class: "text-2xs",
                                    href: __props.parentPage.url
                                }, _toDisplayString(parentPageTitle.value), 9, _hoisted_5)
                            ])
                        ]),
                        _createElementVNode("h1", _hoisted_6, _toDisplayString(__props.title), 1)
                    ]),
                    (__props.subTitle)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.subTitle), 1))
                        : _createCommentVNode("", true)
                ]),
                (hasMedia.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (hasVideoContent.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(HeroMedia, {
                                    videoEmbed: __props.videoEmbed,
                                    mobileVideoEmbed: __props.mobileVideoEmbed,
                                    videoFile: __props.videoFile,
                                    mobileVideoFile: __props.mobileVideoFile,
                                    image: __props.image,
                                    "mobile-image": __props.image,
                                    imageSizes: {
                                        '2xs': '480px',
                                        xs: '700px',
                                        md: '1000px',
                                        '2xl': '1500px',
                                    }
                                }, null, 8, ["videoEmbed", "mobileVideoEmbed", "videoFile", "mobileVideoFile", "image", "mobile-image"])
                            ]))
                            : (_openBlock(), _createBlock(SinglePicture, {
                                key: 1,
                                image: __props.image,
                                extraClasses: "h-full",
                                lazyLoadImage: "eager",
                                class: "mb-6 lg:mb-0",
                                isChildPageHeader: "",
                                sizes: {
                                    '2xs': '480px',
                                    xs: '700px',
                                    md: '1000px',
                                    '2xl': '1500px',
                                }
                            }, null, 8, ["image"]))
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
